'use client'
const useInitialViewType = ({ isAuthenticated, bridgeOnboardingCompleted, isMultiWalletEnabled, isBridgeFlow, connectedWallets, }) => {
    // when multiwallet enabled, and user wants to link wallet
    // show wallet-list view
    if (isAuthenticated || bridgeOnboardingCompleted) {
        return isMultiWalletEnabled ? 'multi-wallet-wallet-list' : 'wallet-list';
    }
    if (isBridgeFlow && !connectedWallets.length) {
        return 'bridge-welcome';
    }
    return 'login-with-email-or-wallet';
};

export { useInitialViewType };
